import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { kecamatanOptions } from './OptionsFilter';
import { useNavigate } from "react-router-dom";

const initialForm = {
  tanggalDiterima: "",
  nomorSurat: "",
  tabggalSurat: "",
  namaPemohonLembagaPengusul: "",
  namaKepalaKeluarga: "",
  nomorKK: "",
  nik: "",
  alamatPemohon: "",
  perihal: "",
  disposisiDari: "",
  catatan: "",
  status: "Diproses",
  kecamatan: "",
  desaKelurahan: "",
  file: null
};

const CreateModal = ({ isOpen, toggle, onSubmit, errors, desaOptions, onKecamatanChange }) => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [localDesaOptions, setLocalDesaOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) {
      setForm(initialForm);
      setLocalDesaOptions([]);
    }
  }, [isOpen]);
  

  // Update local desa options when kecamatan changes
  useEffect(() => {
    if (form.kecamatan && kecamatanOptions[form.kecamatan]) {
      setLocalDesaOptions(kecamatanOptions[form.kecamatan]);
    } else {
      setLocalDesaOptions([]);
    }
  }, [form.kecamatan]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === "file") {
      setForm((prev) => ({ ...prev, file: files && files[0] ? files[0] : null }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      
      // Jika kecamatan berubah, reset desaKelurahan
      if (name === "kecamatan") {
        setForm(prev => ({ ...prev, desaKelurahan: "" }));
        // Panggil callback jika ada
        if (onKecamatanChange) {
          onKecamatanChange(value);
        }
      }
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit(form);
      // PERBAIKAN: Navigate setelah berhasil submit
      toggle(); // Tutup modal terlebih dahulu
      navigate("/rekapdatabantuanrumah"); // Navigate ke halaman rekap
    } catch (error) {
      // Handle error jika diperlukan
      console.error('Submit error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  // Gunakan localDesaOptions untuk dropdown desa
  const currentDesaOptions = form.kecamatan ? localDesaOptions : desaOptions || [];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>Tambah Register Usulan</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Tanggal Terima</Label>
              <Input type="date" name="tanggalDiterima" value={form.tanggalDiterima} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nomor Surat</Label>
              <Input name="nomorSurat" value={form.nomorSurat} onChange={handleChange} />
            </FormGroup>
          </Col>
            <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Tanggal Surat</Label>
              <Input type="date" name="tanggalSurat" value={form.tanggalSurat} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nama Pemohon / Lembaga Pengusul</Label>
              <Input name="namaPemohonLembagaPengusul" value={form.namaPemohonLembagaPengusul} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nama Kepala Keluarga</Label>
              <Input name="namaKepalaKeluarga" value={form.namaKepalaKeluarga} onChange={handleChange} />
            </FormGroup>
          </Col>
           <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nomor KK</Label>
              <Input type="number" name="nomorKK" value={form.nomorKK} onChange={handleChange} />
            </FormGroup>
          </Col>
            <Col md={6} className="mb-3">
            <FormGroup>
              <Label>NIK</Label>
              <Input type="number" name="nik" value={form.nik} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Alamat Pemohon</Label>
              <Input name="alamatPemohon" value={form.alamatPemohon} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Perihal / Usulan</Label>
              <Input type="select" name="perihal" value={form.perihal} onChange={handleChange} >
                <option value="">Pilih</option>
                <option value="Rehab Rumah Tidak Layak Huni">Rehabilitasi Rumah Tidak Layak Huni</option>
                <option value="Pembangunan Rumah Layak Huni">Pembangunan Rumah Layak Huni</option>
                <option value="Meteran Listrik 900 VA">Meteran Listrik 900 VA</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Disposisi Dari</Label>
              <Input name="disposisiDari" value={form.disposisiDari} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label for="kecamatan">Kecamatan</Label>
              <Input 
                type="select" 
                name="kecamatan" 
                id="kecamatan" 
                value={form.kecamatan || ""} 
                onChange={handleChange} 
                className={errors.kecamatan ? "is-invalid" : ""}
              >
                <option value="">Pilih Kecamatan</option>
                {Object.keys(kecamatanOptions).map((kec) => (
                  <option key={kec} value={kec}>
                    {kec}
                  </option>
                ))}
              </Input>
              {errors.kecamatan && <div className="invalid-feedback">{errors.kecamatan}</div>}
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label for="desaKelurahan">Desa/Kelurahan</Label>
              <Input 
                type="select" 
                name="desaKelurahan" 
                id="desaKelurahan" 
                value={form.desaKelurahan || ""} 
                onChange={handleChange} 
                disabled={!form.kecamatan} // Disable jika belum pilih kecamatan
                className={errors.desaKelurahan ? "is-invalid" : ""}
              >
                <option value="">Pilih Desa/Kelurahan</option>
                {currentDesaOptions.map((desa) => (
                  <option key={desa} value={desa}>
                    {desa}
                  </option>
                ))}
              </Input>
              {errors.desaKelurahan && <div className="invalid-feedback">{errors.desaKelurahan}</div>}
            </FormGroup>
          </Col>
          <Col md={12} className="mb-3">
            <FormGroup>
              <Label>Catatan / Tindak Lanjut</Label>
              <Input type="textarea" name="catatan" value={form.catatan} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Status</Label>
              <Input 
                type="text" 
                name="status" 
                value={form.status || "Diproses"} 
                readOnly 
              />
            </FormGroup>
          </Col>

          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Upload File (PDF, maks 5MB)</Label>
              <Input type="file" name="file" accept="application/pdf" onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={submitting}>Batal</Button>
        <Button color="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Menyimpan...' : 'Simpan & Lihat Rekap'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateModal;